export default {
  lang: '中文',
  langList:[
    {
      label:'中文',
      value:'cn',
    },
    {
      label:'英文',
      value:'en',
    },
  ],
  message: {
    hello: '你好',
    copiedToTheClipboard: '链接已复制，到浏览器粘贴打开即可查看',
    fileGenerating: '文件生成中...',
    asterisk: {
      title: '重要提示',
      message: '我们将会以 <strong>****</strong> 代替您无权限查看的内容'
    },
    info: {
      articleTranslateHint: '声明：内容为机器翻译，仅供参考，详情请参考原文。'
    },
    success: {
      favorite: '收藏成功',
      unfavored: '取消收藏成功',
      up: '置顶成功',
      unUp: '取消置顶',
      delete: '删除成功'
    },
    error: {
      server: '服务器错误',
      favorite: '收藏失败!',
      unfavored: '取消收藏失败!',
      up: '置顶失败',
      selectCountry: '请选择需要关注的国家',
      noData: '未获取到数据',
      maximum100: '长度不能超过 100 个字符'
    },
    warning: {
      selectOne: '请至少选择一个需要导出的内容',
      noFavorite: '没有要收藏的项目',
      noId: '没有获取信息所需的ID',
      information: {
        noData: '未获取到数据，返回列表页'
      },
      prompt: {
        title: '提示',
        export: '你确定要导出该栏目下所有列表数据吗?',
        exportFailure: '导出失败'
      },
      exhibition: {
        historyClearUnsupported: '会展库暂不支持清空全部历史',
        historyTopUnsupported: '会展库暂不支持置顶历史',
        historyDeleteUnsupported: '会展库暂不支持删除单条历史'
      }
    }
  },
  rootTitle: '“一带一路”项目商机和风险分析',
  fullScreen: '全屏',
  exitTheFullScreen: '退出全屏',
  exit: '退出',
  loading: '加载中...',
  noMoreData: '没有更多了',
  noData: '暂无数据',
  header: {
    home: '首页',
    bidding: '海外招标',
    exhibition: '国际会展',
    project: '项目',
    information: '资讯',
    analysis: '分析',
    special: '专题'
  },
  theme: {
    white: '浅色',
    dark: '深色'
  },
  tabs: {
    home: {
      latestProject: '最新项目',
      keyProject: '重点项目',
      myProject: '我的项目',
      releaseProject:'请您发布项目',
      projectOpportunity: '项目商机',
      projectRisk: '项目风险',
      projectInformation: '项目资讯',
      projectConcerns: '项目关注',
      addConcerns: '添加关注',
      myCollections: '我的收藏',
      relevantRecommendations: '相关推荐',
      project: '项目',
      opportunity: '商机',
      risk: '风险',
      enterprise: '企业',
      information: '资讯'
    },
    information: {
      projectInformation: '项目资讯',
      opportunityInformation: '商机资讯',
      riskInformation: '风险资讯',
      riskEvent: '风险事件',
      multilateralDynamics: '多边动态'
    },
    analysis: {
      countryComparison: '国家对比',
      industryComparison: '行业对比',
      opportunityAnalysis: '商机分析',
      riskAnalysis: '风险分析',
      networkVolume: '网络声量',
      positiveAndNegativeSidesOfInformation: '信息正负面',
      exportReport: '导出报告',
      projectList:'导出项目列表'
    },
    special: {
      regionalDistribution: '区域分布',
      industryDistribution: '行业分布',
      informationAtlas: '信息图谱',
      hotWordAnalysis: '热词分析'
    }
  },
  charts: {
    home: {
      project: {
        industryDistribution: '行业分布',
        countries: '国家及地区',
        number: '项目数量'
      },
      opportunity: {
        countriesDistribution: '国家及地区',
        distribution: '商机分布',
        trend: '商机趋势',
        number: '类别数量',
        percentage: '占比'
      },
      risk: {
        countriesDistribution: '国家及地区',
        distribution: '风险分布',
        trend: '风险趋势',
        number: '类别数量',
        percentage: '占比'
      }
    },
    analysis: {
      unit: '单位',
      yuan: '元',
      ge: '个',
      tiao: '条',
      exportSelected: '请至少选择一个需要导出的内容',
      exporting: '分析报告正在准备中，请稍等!',
      countryComparison: {
        countryComparisonOfProjectQuantity: '项目数量国家对比图',
        nationalTrendChartOfProjectQuantity: '项目数量国家趋势图',
        countryComparisonChartOfProjectAmount: '项目金额国家对比图',
        nationalTrendChartOfProjectAmount: '项目金额国家趋势图'
      },
      industryComparison: {
        projectQuantityIndustryComparisonChart: '项目数量行业对比图',
        projectQuantityIndustryTrendChart: '项目数量行业趋势图',
        industryComparisonChartOfProjectAmount: '项目金额行业对比图',
        industryTrendChartOfProjectAmount: '项目金额行业趋势图'
      },
      opportunityAnalysis: {
        businessOpportunityCountryTrendChart: '商机国家趋势图',
        businessOpportunityTypeTrendChart: '商机类型趋势图',
        businessOpportunityCountryDistributionMap: '商机国家分布图',
        businessOpportunityTypeDistributionMap: '商机类型分布图'
      },
      riskAnalysis: {
        riskEventCategoryTrendChart: '风险事件类别趋势图',
        nationalTrendChartOfRiskEvents: '风险事件国家趋势图',
        riskEventCategoryDistributionMap: '风险事件类别分布图',
        countryDistributionMapOfRiskEvents: '风险事件国家分布图'
      },
      networkVolume: {
        volumeInformationTrendChart: '项目声量趋势图',
        informationSourceTrendChart: '项目声量国家趋势图',
        distributionMapOfInformationSources: '项目声量国家分布图',
        comparisonOfInformationSources: '项目声量来源分布图'
      },
      positiveAndNegativeSidesOfInformation: {
        positive: '正面',
        negative: '负面',
        informationPositiveAndNegativeComparisonDiagram: '信息正负面对比图',
        proportionOfSensitiveInformation: '信息正负面国家对比图',
        positiveInformationTrendChart: '正面信息走势图',
        distributionOfPositiveInformationSources: '正面信息来源分布图',
        sensitiveInformationTrendChart: '负面信息走势图',
        distributionOfSensitiveInformationSources: '负面信息来源分布图'
      }
    },
    special: {
      industryDistribution: {
        name: '行业分布'
      },
      regionalDistribution: {
        name: '区域分布'
      }
    }
  },
  buttons: {
    okButton: '确定',
    ok: '确定',
    cancelButton: '取消',
    cancel: '取消',
    search: '查询',
    reset: '重置',
    edit: '确定',
    close: '关闭',
    more: '更多',
    submit: '提交申请',
    searchHistory: '搜索历史',
    delAll: '全部删除',
    advanceRetrieval: '高级检索<i class=\'el-icon-arrow-{type} el-icon--right\'></i>',
    export: '导出',
    back: '返回',
    switch: {
      fuzzy: '模糊',
      accurate: '精准'
    },
    home: {
      mapDetailButton: '详情 >>'
    },
    project: {
      publishProject: '发布项目',
      projectAnalysis: '项目分析'
    },
    information: {
      time: '时间',
      correlationDegree: '相关度'
    },
    analysis: {},
    special: {},
    personal: {
      focus: '关注'
    }
  },
  label: {
    continent: '洲',
    country: '国家',
    enterprise: '企业',
    industry: '行业',
    category: '项目类别',
    stage: '项目阶段',
    amount: '项目金额',
    signDate: '签订日期',
    keyProject: '重点项目',
    theDateRange: '日期范围',
    date: '日期',
    source: '来源',
    implement: '实施',
    signAContract: '签约',
    trade: '贸易类',
    capitalConstruction: '基建类',
    investmentAndFinancing: '投融资',
    home: {
      keywordInputPlaceholder: '请输入关键字',
      filterTableColumnName: '名称',
      filterTableColumnLogo: '国旗',
      date: '日期',
      amount: '金额',
      country: '国家',
      type: '类型',
      enterprise: '企业',
      loadDataError: '数据加载失败',
      retry: '重试',
      map: {
        download: '下载',
        country: '国家名称',
        number: '项目数量',
        printing: '开始打印当前可视范围内的地图...',
        project: '项 目',
        opportunity: '商 机',
        risk: '风 险',
        tooltip:{
          xm:'项目列表',
          sj:'商机列表',
          fx:'风险列表'
        }
      }
    },
    project: {
      country: '国家: ',
      enterprise: '企业: ',
      industry: '行业: ',
      category: '项目类别: ',
      stage: '项目阶段: ',
      amount: '项目金额: ',
      signDate: '签订日期: ',
      keyProject: '重点项目: ',
      date: '日期: ',
      searchCondition: '我的搜索条件',
      projectData: '项目数据',
      projectHotWords: '项目热词',
      total: '总共',
      projectNumber: '项目数量',
      countriesInvolved: '涉及国家',
      projectAmount: '项目金额',
      industriesInvolved: '涉及行业',
      individual: ' 个',
      HM: '',
      million: '百万',
      publish: {
        myPublish: '我的发布',
        title: '发布项目',
        submitSuccess: '发布成功',
        submitFailure: '发布失败',
        base: {
          title: '基本信息',
          projectName: '项目名称',
          investmentAmount: '投资金额',
          projectCountry: '项目国家',
          detailedAddress: '详细地址',
          projectIndustry: '项目行业',
          projectType: '项目类型',
          participationMode: '参与方式',
          projectStatus: '项目状态',
          unitName: '单位名称',
          financingSituation: '融资情况',
          overview: '项目概述',
          signDate: '合同签订日期',
          signAmount: '合同鉴定金额',
          planStartDate: '计划开工日期',
          planEndDate: '计划完工日期',
          realityStartDate: '实际开工日期',
          realityEndDate: '实际完工日期',
          planBuildCycle: '计划建设周期',
          realityBuildCycle: '实际建设周期',
          lang:'语言'
        },
        contact: {
          title: '联系信息',
          contact1: '联系人1',
          mobile1: '手机号码1',
          email1: '电子邮箱1',
          telephone1: '固定电话1',
          contact2: '联系人2',
          mobile2: '手机号码2',
          email2: '电子邮箱2',
          telephone2: '固定电话2'
        }
      },
      detail: {
        title: '项目内容',
        basicInformation: '基本信息',
        projectName: '项目名称',
        projectBrief: '项目概述',
        countryOrRegion: '国别/地区',
        signDate: '合同签订日期',
        updateDate: '更新日期',
        projectIndustry: '项目行业',
        projectStage: '项目阶段',
        constructionCycle: '建设周期',
        projectType: '项目类型',
        projectAmount: '项目金额',
        projectContact:'项目联系人',
        subsidiaryOrgan:'联系人所属机构',
        position:'联系人职位',
        projectBidPublishDate:'招标发布时间',
        projectEndDate:'招标截止时间',
        contact: '联系方式',
        enterpriseName: '企业名称',
        constructionName: '承建单位',
        owner:'项目甲方',
        otherInformation: '其他信息',
        constructionInformation: '建设情况',
        investmentInformation: '投资情况',
        tradeInformation: '贸易情况',
        planStartDate: '计划开工日期',
        planEndDate: '计划完工日期',
        excutedMode: '执行方式',
        realityStartDate: '实际开工日期',
        realityEndDate: '实际完工日期',
        projectConstructionCycle: '实际建设周期',
        technicalStandard:'技术标准',

        financingSubject:'融资主体',
        financingPurpose:'融资用途',
        investor:'投资主体',
        finRevenueProfit:'去年营收利润',
        finCurrentAssets:'当前净资产',
        finFinanceMoney:'融资金额',
        finFinanceStage:'融资阶段',
        finFinanceWay:'融资方式',

        importExportType:'进出口类型',
        startEndTime:'起止时间',
        currencySystem:'币制',
        tradingPartners:'贸易伙伴',
        tradeMode:'贸易方式',
        placeRegistrationReceive:'收发货人注册地',
        customsCategory:'关别',
        shippingType:'运输方式',

        historyInformation: '动态追踪',
        no: '序号',
        updateContent: '更新内容',
        relatedInformation: '关联资讯',
        update: '更改日期',
        mileStone: '里程碑',
        demandBudget:'需求预算',
        bidType:'招标类型',
        projectDomain:'项目领域',
        projectWinning: '项目中标',
        projectSigning: '合同签订',
        projectStarted: '项目开工',
        stageAcceptance: '阶段验收',
        projectCompletion: '项目竣工',
        projectAtlas: '项目图谱',
        relatedEnterprises: '相关企业',
        relatedIndustries: '相关行业',
        relatedProjects: '相关项目',
        relevantRiskEvents: '相关风险',
        externalPoliticalRisk: '外部政治风险',
        sovereignPoliticalRisk: '主权政治风险',
        riskOfSocialUnrest: '社会动荡风险',
        riskOfRelationsWithChina: '对华关系风险',
        capitalRisk: '资金风险',
        financialRisk: '财政风险',
        inflationRisk: '通货膨胀风险',
        exchangeRateRisks: '汇率风险',
        environmentalRisk: '环保风险',
        legalRisk: '法律风险',
        emergencyRisk: '突发事件风险',
        projectImplementationRisk: '项目实施风险',
        enterpriseRisk: '企业风险',
        otherRisks: '其他风险',
        relevantNationalLaws: '商务指南',
        policiesAndRegulations:'当地政策法规',
        commonWebsiteLinks:'常用网站链接',
        projectAttachments:'项目附件',
        fileName:'附件名称',
        previewLink:'点击预览',
        countryRelatedInformation: '国家相关信息',
        relevantInformation: '相关资讯',
        relatedBusinessOpportunities: '相关商机',
        disclaimer: '免责声明',
        disclaimerContent: '本板块项目信息均来源于境外政府、国际组织等可追溯的公开渠道（以下简称“信息来源方”）。平台已对信息源的可信度进行审慎判断，但无法对信息来源方所发布内容的准确性、完整性、时效性作出任何担保或承诺。如因信息来源方发布的信息存在错误、遗漏或更新延迟，或因不可抗力、技术障碍等非因平台故意或重大过失导致的情形，本平台不承担法律责任。本平台以电子形式呈现的项目详情内容，如与项目业主正式发布的内容不一致的，一律以业主发布内容为准。因境外项目受到项目所在国或地区的政治、经济、法律、文化、汇率波动及政策变动等多种复杂因素的重大影响，存在较高不确定性及固有风险；平台不对项目的合规性、可行性及各类潜在风险作任何评估，用户需自行咨询专业机构。',
        contactHint: '如需更多项目详情信息请联系电话：010-88057118或4006123115',
      },
      status:{
        1:'有效',
        2:'失效',
        0:'未知'
      }
    },
    exhibition: {
      exhibitionNumber: '会展数量',
      onGoingExhibition: '在办会展',
      upcomingExhibition: '待办会展',
      internationalExhibition: '国际会展',
      globalProject: '全球项目',
      overseasTendering: '海外招标',
      exhibitionData: '会展数据',
      exhibitionHotWords: '会展热词',
      holdStatus: '会展状态',
      holdStatusPlaceholder: '请选择会展状态',
      holdStartDate: '举办开始日期',
      holdEndDate: '举办结束日期',
      nextStartDate: '下届开始日期',
      nextEndDate: '下届结束日期',
      holdDate: '举办日期',
      nextDate: '下届日期',
      holdCycle: '举办周期',
      cycleTimes: '次',
      detail: {
        title: '会展详情',
        basicInformation: '基本信息',
        exhibitionName: '会展名称',
        city: '城市',
        industry: '会展行业',
        relatedField: '相关领域',
        audience: '观众群体',
        holdDate: '举办日期',
        nextHoldDate: '下届举办日期',
        venueInfo: '展馆信息',
        venueName: '展馆名称',
        venueAddress: '展馆地址',
        venueContact: '展馆联系方式',
        organizerInfo: '组织者信息',
        organizerName: '组织者名称',
        organizerAddress: '组织者地址',
        organizerContact: '组织者联系方式',
        description: '展会描述'
      }
    },
    enterprisePage: {
      detail: {
        basicInformation: '基本信息',
        title: '企业详情',
        projectList: '项目列表',
        enterpriseAtlas: '企业图谱',
        relevantInformation: '相关资讯',
        unifiedCreditCode: '统一信用代码',
        legalRepresentative: '法定代表人姓名',
        operatingStatus: '经营状态',
        dateOfEstablishing: '成立日期',
        companyType: '公司类型',
        province: '省份',
        usedName: '曾用名',
        registrationAuthority: '登记机关',
        chinessName: 'Chiness Name',
        englishName: '英文名',
        contactNumber: '联系电话',
        natureOfBusiness: '经营范围',
        noCompanyInfo: '未检索到该企业基本信息'
      }
    },
    information: {
      category: '类别',
      informationHotWords: '资讯热词',
      informationHotspot: '资讯热点',
      informationRiskHotWords: '风险热词',
      informationRiskHotspot: '风险热点',
      multilateral: {
        org: '多边组织',
        region: '区域',
        infoType: '资讯类型',
        infoCategory: '资讯分类',
        regionOverview: '区域速览',
        dynamicsUnit: '条动态',
        detailTitle: '多边动态详情',
        publishTime: '发布时间：',
        andMore: '等',
        disclaimer: '【声明：内容系对国内外公开报道进行事实性摘编与客观转述，仅供参考。力求准确但不保证完全无误，事实偏差请以原始报道为准。】'
      },
      detail: {
        title: '资讯详情',
        projectTitle: '项目资讯详情',
        riskTitle: '风险资讯详情',
        businessTitle: '商机资讯详情',
        source: '来源：',
        author: '作者：',
        originalLink: '复制原文链接',
        originalDetails: '原文详情',
        translateDetails: '译文详情',
        informationAtlas: '资讯图谱',
        relevantInformation: '相关资讯',
        summary: '摘要：',
        time: '原链接发布时间：',
        publishDate: '数据库发布时间：'
      },
      business: {
        title: '商机详情',
        relatedItems: '相关项目'
      },
      risk: {
        title: '风险详情',
        relatedEnterprises: '相关企业',
        updatedTime: '更新时间：'
      }
    },
    analysis: {
      atlasAnalysis: '图谱分析',
      hotWordAnalysis: '热词分析',
      country: '国家: ',
      enterprise: '企业: ',
      signDate: '签订日期: ',
      industry: '行业: ',
      phase: '项目阶段: ',
      category: '项目类别: ',
      amount: '项目金额: ',
      exportReport: {
        title: '报告内容选择',
        summary: '概述',
        projectInformation: '项目信息（五十条以内）',
        watermark: '有水印',
        watermarkNo: '无水印',
        cancel: '取消',
        confirm: '确定',
      }
    },
    special: {
      key: '“测试系统”专题',
      title: '中国银行成功协办“企业家大会对接洽谈活动',
      summary: '4月25日下午，第二届“测试系统”国际合作高峰论坛企业家大会对接洽谈活动在国家会议中心（北京）成功举行。本次对接洽谈由中国国际贸易促进委员会、中华全国工商业联合会、国务院国有资产监督管理委员会主办，中国国际商会承办，中国银行协办。',
      distributionOfRelatedProjects: '相关项目分布',
      projectRelatedInformation: '项目相关信息',
      relatedItems: '相关项目',
      relevantInformation: '相关资讯',
      regionalDistributionDesc: '2005-2016年期间，中国银行支持对测试系统国家的总投资额为2047亿美元，总体呈现上升趋势，测试系统的四大区域中，东亚、西亚地区占据了投资的大部分，上升趋势相对更加显著。',
      industryDistributionDesc: '中国银行先后与菲律宾、捷克、柬埔寨等多个国家签订了测试系统合作备忘录，大力的支持了测试系统沿线国家项目的开展与投资。',
      informationAtlasDesc: '中国银行先后与菲律宾、捷克、柬埔寨等多个国家签订了测试系统合作备忘录，大力的支持了测试系统沿线国家项目的开展与投资。',
      hotWordAnalysisDesc: '2005-2016年期间，中国银行支持对测试系统国家的总投资额为2047亿美元，总体呈现上升趋势，测试系统的四大区域中，东亚、西亚地区占据了投资的大部分，上升趋势相对更加显著。',
    more:{
      projectTitle:'更多项目',
      infoTitle:'更多资讯',
    }
    },
    personal: {
      setMyAttention: '设置我的关注',
      moreCountry: '更多国家',
      focused: '已关注',
      myFocused: '我的关注'
    },
    export: {
      projectList: '项目列表',
      biddingList: '海外招标项目列表',
      exhibitionList: '会展列表',
      project: '项目详情 - ',
      infoList: '资讯列表',
      info: '资讯详情 - ',
      riskList: '风险列表',
      risk: '风险详情 - ',
      multilateralList: '多边动态列表',
      multilateral: '多边动态详情 - '
    }
  },
  placeholders: {
    pleaseSelect: '请选择',
    project: {
      search: '请输入项目名称、行业、类别等关键字',
      searchByName: '请输入项目名称',
      publish: {
        base: {
          title: '基本信息',
          projectName: '请输入项目名称',
          investmentAmount: '请输入投资金额',
          projectCountry: '请选择国家',
          detailedAddress: '请输入详细地址',
          projectIndustry: '请选择行业',
          projectType: '请选择项目类型',
          participationMode: '请选择参与方式',
          projectStatus: '请选择项目状态',
          unitName: '请输入单位名称',
          financingSituation: '请输入投融资情况',
          overview: '请输入项目概述',
          signDate: '请选择合同签订日期',
          signAmount: '请输入合同鉴定金额',
          planStartDate: '请选择计划开工日期',
          planEndDate: '请选择计划完工日期',
          realityStartDate: '请选择实际开工日期',
          realityEndDate: '请选择实际完工日期',
          planBuildCycle: '请输入计划建设周期',
          realityBuildCycle: '请输入实际建设周期',
          lang:'请选择语言'
        },
        contact: {
          title: '联系人信息',
          contact1: '请输入联系人1',
          mobile1: '请输入手机号码1',
          email1: '请输入电子邮箱1',
          telephone1: '请输入固定号码1',
          contact2: '请输入联系人2',
          mobile2: '请输入手机号码2',
          email2: '请输入电子邮箱2',
          telephone2: '请输入固定号码2'
        }
      }
    },
    information: {
      theDateRange: '日期范围',
      keywords: '请输入关键字',
      selectOrSearch: '请选择或输入检索',
      source: '请输入来源'
    },
    exhibition: {
      search: '请输入会展名称、国家、行业等关键字'
    }
  },
  table: {
    exhibition: {
      main: {
        name: '会展名称',
        city: '城市',
        holdDate: '举办日期',
        holdCycle: '举办周期',
        industry: '会展行业'
      }
    },
    project: {
      main: {
        no: '序号',
        title: '标题',
        amount: '签约金额(万元)',
        industry: '行业',
        state: '状态',
        phrase: '项目阶段',
        type: '类别',
        enterprise: '企业',
        keyProject: '重点项目',
        yes: '是',
        orNo: '否',
        country: '国家',
        date: '签订日期',
        biddingProjectType: '项目类型',
        projectDomain: '项目领域',
      },
      history: {
        title: '搜索历史',
        columns: {
          title: '历史搜索条件',
          top: '置顶',
          delete: '删除'
        }
      }
    },
    analysis:{
      num:'数量',
      amount: '金额',
      date: '日期',
      source:'来源',
      type:'类型',
      percentage:'占比',
      positive:'正面信息数量',
      negative:'负面信息数量'
    },
    history: {
      title: '搜索历史',
      columns: {
        title: '历史搜索条件'
      }
    },
    topic:{
      list:{
        no: '序号',
        title: '标题',
        summary: '摘要',
        releaseTime: '发布时间'
      }
    },
    myProject: {
      columns:{
        title:'标题',
        status:'状态',
        time:'发布时间',
        operate:'操作',
      },
      operate:{
        edit:'编辑',
        delete:'删除',
      }
    }
  },
  datePicker: {
    threeMonths: '近3个月',
    oneYear: '近一年内',
    threeYears: '近3年内'
  },
  rules: {
    maximum: '长度不能超过 {num} 个字符',
    publishProject: {
      maximum100: '长度不能超过 100 个字符',
      maximum50: '长度不能超过 50 个字符',
      number: '必须为数字',
      contact: {
        mobile1: '手机格式不正确',
        email1: '邮箱格式不正确',
        telephone1: '固话格式不正确',
        mobile2: '手机格式不正确',
        email2: '邮箱格式不正确',
        telephone2: '固话格式不正确'
      }
    }
  }
}
